"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  LIKE: 'like',
  RECOMMEND: 'recommend'
};
exports.default = _default;
//# sourceMappingURL=LikeAction.js.map